import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import checkIcon from '@lifesize/ux-assets/vectors/svgIcons/check.svg';
import classes from 'components/SourceDisplay/SourceDisplay.module.scss';

class MicrophoneMute extends React.Component {
  toggleAudio = () => {
    this.props.toggleAudioMuteSetting(!this.props.defaultAudioSetting);
  };

  render() {
    if (!this.props.toggleAudioMuteSetting) return null;
    return (
      <label
        className={classes.checkboxContainer}
        data-testid="auto-mic-mute"
      >
        {this.props.isStartingCall ?
          <FormattedMessage
            id="components.sourceDisplay.rememberCurrentAudio"
            defaultMessage="Start with microphone muted"
          /> :
          <FormattedMessage
            id="components.sourceDisplay.rememberAudio"
            defaultMessage="Always start with microphone muted"
          />
        }
        <input
          checked={!this.props.defaultAudioSetting}
          id="audioSettings"
          name="audioSettings"
          onChange={this.toggleAudio}
          type="checkbox"
        />
        <SVG src={checkIcon} data-testid="checkIcon" />
      </label>
    );
  }
}

MicrophoneMute.propTypes = {
  toggleAudioMuteSetting: PT.func,
  defaultAudioSetting: PT.bool,
  isStartingCall: PT.bool
};

export default MicrophoneMute;
